import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FolderPermissionsFragment = { __typename?: 'FolderAsset', id: string, permissions?: { __typename?: 'FolderPermissions', canEditTranscription: boolean, canAccessWithoutWatermark: boolean, canConvertInteractiveAsset: boolean, canCopyChildren: boolean, canCopyComment: boolean, canCreateChildren: boolean, canCreateComment: boolean, canCreateCommentAttachment: boolean, canDeleteChildren: boolean, canDeleteComment: boolean, canDeleteCommentAttachment: boolean, canDownloadChildren: boolean, canDownloadComment: boolean, canDownloadCommentAttachment: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean, canMoveChildren: boolean, canPrintComment: boolean, canReactToComment: boolean, canRestoreChildren: boolean, canShareChildren: boolean, canUpdateChildren: boolean, canUpdateCommentStatus: boolean, canVersionChildren: boolean, canView: boolean, canViewChildren: boolean, canViewComment: boolean, canViewUserGroup: boolean, canViewUserPermissions: boolean } | null };

export const FolderPermissions = /*#__PURE__*/ gql`
    fragment FolderPermissions on FolderAsset {
  id
  permissions {
    canEditTranscription
    canAccessWithoutWatermark
    canConvertInteractiveAsset
    canCopyChildren
    canCopyComment
    canCreateChildren
    canCreateComment
    canCreateCommentAttachment
    canDeleteChildren
    canDeleteComment
    canDeleteCommentAttachment
    canDownloadChildren
    canDownloadComment
    canDownloadCommentAttachment
    canEditUserPermissions
    canManageResourceControlPolicies
    canMoveChildren
    canPrintComment
    canReactToComment
    canRestoreChildren
    canShareChildren
    canUpdateChildren
    canUpdateCommentStatus
    canVersionChildren
    canView
    canViewChildren
    canViewComment
    canViewUserGroup
    canViewUserPermissions
  }
}
    ` as unknown as DocumentNode<FolderPermissionsFragment, unknown>;

        

        
export const useFolderPermissionsFragment = (
  input: string | Omit<UseFragmentOptions<FolderPermissionsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<FolderPermissionsFragment>({
    fragment: FolderPermissions,
    fragmentName: 'FolderPermissions',
    ...options,
  });
};
  
        